import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-pigpen-editor',
  templateUrl: './pigpen-editor.component.html',
  host: { '(window:keydown)': 'onKeyDown($event)', '(window:keyup)': 'onKeyUp($event)' },
  styleUrls: ['../topic-style.css', './pigpen-editor.component.css']
})
export class PigpenEditorComponent extends GeneralComponent {

  constructor(protected topicService: TopicService) {
    super(topicService)
  }

  @Input() modus: string;

  @Input() errors: number[] =[];

  @Input()
  set textIn(value: string) {
    if(value){
    if (this.modus == "read") {
      this.text = value.toUpperCase().split("");
    } else {
      this.text = [];
      for(let d of value)
      this.text.push(d);
    }
  }
  }

  @Output() selectedOut = new EventEmitter<number>();

  @Input() selected = 0;

  @Output() textOut: EventEmitter<string>;

  text: string[];

  /** set the i-th letter to char */
  set(i:number, char: any){
    if(!char || !char.dragData){
      return;
    }
    this.text[i] = char.dragData;
    this.selected = i+1;
    while (this.text[this.selected] === " ") {
      this.selected++;
    }
    this.selectedOut.emit(this.selected);
  }

  /** handle key event, only accept arrows and backspace */
  onKeyDown(event) {
    if(this.modus=="read"){
      return;
    }
    if (document.activeElement.tagName == "INPUT"|| document.activeElement.tagName == "TEXTAREA") {
      return;
    }
    let backspace = 8;
    if (event.keyCode == backspace && this.selected > 0){
      this.selected--;
      while (this.text[this.selected] === " " ) {
        this.selected -= 1;
      }
      this.text[this.selected] = "#";
    }
    if (event.keyCode == 37 && this.selected > 0) {
      this.selected -= 1;
      while (this.text[this.selected] === " ") {
        this.selected -= 1;
      }
    }

    if (event.keyCode == 39 && this.selected < this.text.length - 1) {
      this.selected++;
      while (this.text[this.selected] === " ") {
        this.selected++;
      }
    }
  }

  /** emit the current text */
  onKeyUp() {
    if(this.modus=="read"){
      return;
    }
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      return;
    }
    this.selectedOut.emit(this.selected);

  }

  /** set highlight on click */
  onClick(position: number) {
    if(this.modus=="read"){
      return;
    }
    if (document.activeElement.tagName == "INPUT" || document.activeElement.tagName == "TEXTAREA") {
      return;
    }
    this.selected = position;
    while (this.text[this.selected] == " ") {
      this.selected++;
    }
    this.selectedOut.emit(this.selected);
  }

  /** returns the current text */
   getText(): string {
    return this.text.join("");
  }

}
